<template>
    <div>
        <a-page-header class="page-header icon" @back="() => null">
            <svg class="icon" aria-hidden="true" slot="backIcon" @click="$router.replace('/member')">
                <use xlink:href="#icon-jiazheng_kehu2" />
            </svg>

            <template #subTitle>
                {{ sub_title }}
                <span class="sub-desc" v-if="sub_description"
                    ><a-icon type="info-circle" style="margin-right:4px" />{{ sub_description }}</span
                >
            </template>

            <template #title>客户管理<a-icon class="separator" type="right" /> </template>

            <template slot="extra">
                <div class="extra-shortcut">
                    <a-icon type="plus-circle" class="pointer" @click="on_add_shortcut" />
                </div>
            </template>
        </a-page-header>

        <div class="framework-container">
            <div
                class="framework-side"
                :class="[visible_sidebar ? 'visible' : '', small_screen ? 'ss' : '', visible_sidebar ? 'tg-on' : 'tg-off']"
            >
                <div class="module-title">
                    客户管理
                </div>
                <div class="menu">
                    <a-menu
                        mode="inline"
                        :default-open-keys="['system', 'custom', 'other', 'tags']"
                        :selected-keys="sidebar_selected"
                        :inlineIndent="16"
                        ref="sidebar-menu"
                    >
                        <a-menu-item v-if="permissible.indexOf('member') > -1" key="whole" @click="$router.push('/member/whole')">
                            客户列表
                            <div style="float: right;">
                                <a-badge v-if="data_stat.total" :count="data_stat.total" :overflowCount="999" class="sidebar-badge" />
                            </div>
                        </a-menu-item>

                        <a-menu-item key="public" @click="$router.push('/member/public')">
                            公海客户
                            <div style="float: right;">
                                <div class="count">
                                    <a-badge v-if="data_stat.public" :count="data_stat.public" :overflowCount="999" class="sidebar-badge" />
                                </div>
                            </div>
                        </a-menu-item>

                        <a-menu-item key="distribute" @click="$router.push('/member/distribute')">
                            分配给我的客户
                            <div style="float: right;">
                                <a-badge
                                    v-if="data_stat.unread_distribute"
                                    :count="data_stat.unread_distribute"
                                    :overflowCount="999"
                                    class="sidebar-badge"
                                />
                            </div>
                        </a-menu-item>

                        <a-menu-item key="register" @click="$router.push('/member/register')">
                            在线咨询
                            <!-- <div style="float: right;">
                                <div class="count">
                                    <a-badge v-if="data_stat.public" :count="data_stat.public" :overflowCount="999" class="sidebar-badge" />
                                </div>
                            </div> -->
                        </a-menu-item>

                        <a-menu-item key="certification" @click="$router.push('/member/certification')">
                            实名认证
                            <!-- <div style="float: right;">
                                <div class="count">
                                    <a-badge v-if="data_stat.public" :count="data_stat.public" :overflowCount="999" class="sidebar-badge" />
                                </div>
                            </div> -->
                        </a-menu-item>

                        <!-- <a-menu-divider/>
                        <a-sub-menu key="tags" v-if="data_tags.length">
                            <span slot="title" class="item-title">
                                <a-icon type="tags" />
                                <span>客户标签</span>
                            </span>
                            <a-menu-item v-for="tag in data_tags" :key="'tag_' + tag.id" @click="on_tagjump('/tag/' + tag.id)">
                                <a-tooltip>
                                    <template slot="title">{{ tag.remark }}</template>
                                    <i class="anticon-icon icon-mn_sousuoleimu" v-if="tag.is_term"></i>
                                    {{ tag.name | ellipsis(8) }}
                                </a-tooltip>

                                <div style="float: right;">
                                    <a-badge :count="tag.item_count" :overflowCount="999" class="sidebar-badge" /></div
                            ></a-menu-item>
                        </a-sub-menu> -->
                    </a-menu>
                </div>
            </div>

            <div class="framework-body" :class="[visible_sidebar ? 'tg-on' : 'tg-off', small_screen ? 'ss' : '']">
                <router-view />
            </div>
        </div>

        <!-- 新建标签 -->
        <modal_tag_list />

        <!-- 分配销售 -->
        <modal_distribute />
    </div>
</template>

<script>
    import modal_tag_list from "./components/modal_tag_list.vue";
    import modal_distribute from "./components/modal_distribute.vue";
    import moment from "moment";
    import commonjs from "./mixins/common";

    export default {
        mixins: [commonjs],
        components: {
            modal_distribute,
            modal_tag_list,
        },
        data() {
            return {
                sub_title: "客户列表",
                sub_description: null,
                sub_count: null,
                path: "/member",
                loading: false,
                mode_folder: "create",
                visible_folder: false,
                selected_folder: null,
                menu: [
                    {
                        name: "总览",
                        value: "",
                    },
                    {
                        name: "客户列表",
                        value: "whole",
                    },
                    {
                        name: "我的客户",
                        value: "my",
                    },
                    {
                        name: "已删除",
                        value: "deleted",
                    },
                    {
                        name: "公海客户",
                        value: "public",
                    },
                    {
                        name: "分配给我的客户",
                        value: "distribute",
                    },
                    {
                        name: "在线咨询",
                        value: "register",
                    },
                    {
                        name: "实名认证",
                        value: "certification",
                    },
                ],
            };
        },
        watch: {
            $route() {
                this.menu_subtitle();
            },
        },
        created() {
            this.load_tags();
            this.menu_subtitle();
            this.$store.commit("change_state", {
                name: "sidebar_key",
                value: "member",
            });
        },
        computed: {
            profile() {
                return this.$store.state.profile;
            },
            sidebar_selected() {
                return [this.$store.state.member_sidebar_selected];
            },
            data_stat() {
                return this.$store.state.stat_member;
            },
            data_tags() {
                return this.$store.state.member_sidebar_tags;
            },
        },
        methods: {
            moment,
            menu_subtitle() {
                this.$nextTick(() => {
                    this.sub_description = false;
                    this.sub_count = null;
                    const v = this.sidebar_selected[0];
                    const filtered = this.menu.filter((e) => {
                        if (e.value == v) {
                            this.sub_title = e.name;

                            return true;
                        }
                    });
                    if (!filtered.length) {
                        this.data_tags.map((e) => {
                            if ("tag_" + e.id == v) {
                                this.sub_title = `标签：${e.name}`;
                                this.sub_description = e.remark;
                                this.sub_count = e.item_count;
                            }
                        });
                    }
                });
            },
            on_tagjump(v) {
                return this.$router.push(`/member${v}`);
            },
        },
    };
</script>

<style lang="less" scoped>
    .framework-container {
        .framework-body {
            position: absolute;
            left: 200px;
            right: 0;
            bottom: 0;
            top: 0;
            .main {
                overflow-y: auto;
                position: absolute;
                top: 57px;
                left: 0;
                right: 0;
                bottom: 0;
            }
        }
    }
    .stat {
        display: table-cell;
        vertical-align: bottom;
        padding-right: 12px;
        &:last-child {
            padding-right: 0;
        }
        .value {
            font-size: 18px;
        }
        .symbol {
            margin: 0 2px;
        }
        .text {
            color: rgba(0, 0, 0, 0.45);
            font-size: 14px;
        }
    }

    .contact {
        width: 110px;
        font-size: 12px;
    }
    .expense {
        font-size: 12px;
    }

    .area {
        .city {
            font-size: 12px;
            color: rgba(0, 0, 0, 0.45);
        }
    }

    .tag {
        margin-right: 0;
    }

    .badget-color {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        display: inline-block;
        margin-right: 8px;
    }
</style>
